import { render, staticRenderFns } from "./Forecasts.vue?vue&type=template&id=ef6d5be6&"
import script from "./Forecasts.vue?vue&type=script&lang=js&"
export * from "./Forecasts.vue?vue&type=script&lang=js&"
import style0 from "./Forecasts.vue?vue&type=style&index=0&id=ef6d5be6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports